const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-4E58240BBA48-NEW-CIRCUIT-EHIXBIT-B-123211123'; // to be updated

//location form actions
export const setCountryOptions = `SET-NEW-CIRCUIT-EXHIBIT-B-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
//subscription form actions
export const setPlanOptions = `SET-NEW-CIRCUIT-EXHIBIT-B-PLANS-OPTIONS-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-NEW-CIRCUIT-EXHIBIT-B-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-NEW-CIRCUIT-EXHIBIT-B-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setPrimaryPlanDetails = `SET-NEW-CIRCUIT-EXHIBIT-B-PRIMARY-PLAN-DETAILS-${actionTypeIdentifier}`;
//business form actions
export const setPurposeOfUseOptions = `SET-NEW-CIRCUIT-EXHIBIT-B-PURPOSE-OF-USE-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-NEW-CIRCUIT-EXHIBIT-B-FORM-SUBMITTED-${actionTypeIdentifier}`;

export const wirelineLocationModelB = {
    countryCode: ''
    , country: ''
    , wirelineDeliveryAddress: ''
    , companyCode: ''
}

export const wirelineSubscriptionModelB = {
    vendorDetailId: ''
    , planId: 0
    , planDetails: {
        planComponents: []
    }
    , planDetailsModel: []
    , quantity: 0
    , totalCost: 0
}

export const wirelineBusinessModelB = {
    wireLineApproverId: 0
    , purposeOfUseId: 0
    , additionalInformation: ''
}